import { useState } from 'react';

function BanquetHelpPanel({ visible = false, onOpenFaq }) {
  const [open, setOpen] = useState(false);
  if (!visible) return null;

  return (
    <div style={{ marginBottom: '0.8rem' }}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{ padding: '0.5rem 0.9rem', borderRadius: '6px', border: '1px solid var(--theme-primary)', background: '#e6f0fa', color: 'var(--theme-primary)', cursor: 'pointer', fontWeight: 'bold' }}
      >
        Help (Banquet User Manual)
      </button>

      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
          <div style={{ width: 'min(900px, 100%)', maxHeight: '90vh', overflowY: 'auto', background: '#fff', borderRadius: '10px', border: '1px solid #dbeafe', padding: '1rem 1.1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.6rem' }}>
              <h3 style={{ margin: 0, color: 'var(--theme-primary)' }}>Banquet Training Guide</h3>
              <button type="button" onClick={() => setOpen(false)} className="btn-danger" style={{ border: 'none', borderRadius: '6px', padding: '0.35rem 0.6rem', cursor: 'pointer' }}>Close</button>
            </div>

            <ol style={{ paddingLeft: '1.1rem' }}>
              <li>Masters setup: create hall(s) and hall layout capacity for each usable arrangement.</li>
              <li>Quotation: enter customer details, event dates, expected pax, and estimated value.</li>
              <li>Approval: select hall + layout and approve quotation to convert it into tentative booking.</li>
              <li>Calendar lock: system marks event dates as TENTATIVE and blocks overlaps.</li>
              <li>Advance payment: post advance/partial payment. Booking becomes CONFIRMED when advance threshold is met.</li>
              <li>Invoice: post final invoice after event completion.</li>
              <li>Advance adjustment: adjust received advance against invoice balance.</li>
              <li>Refund: if applicable, post refund and verify ledger entries.</li>
              <li>Ledger verification: confirm each finance transaction is balanced (debit = credit).</li>
              <li>Auto-lock: overdue/unpaid advance conditions will auto-lock bookings until payment compliance.</li>
            </ol>

            <div style={{ marginTop: '0.8rem', padding: '0.7rem', background: 'var(--theme-bg-light)', border: '1px solid var(--theme-border)', borderRadius: '8px' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.35rem' }}>Training Notes</div>
              <div>Use the Banquet screens in sequence: Quotations -> Bookings & Invoices -> Payments & Ledger -> Calendar.</div>
              <div>For role/permission issues, verify selected property/outlet and user permission mapping first.</div>
            </div>

            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.9rem' }}>
              <button
                type="button"
                onClick={() => {
                  if (typeof onOpenFaq === 'function') onOpenFaq();
                  setOpen(false);
                }}
                style={{ padding: '0.5rem 0.9rem', borderRadius: '6px', border: '1px solid #166534', background: '#dcfce7', color: '#166534', cursor: 'pointer' }}
              >
                Open FAQ Assistant
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BanquetHelpPanel;
